import { getYoutubeId } from "@/services/utils/general";
import { Box } from "@chakra-ui/react";

export default function YoutubeVideoPlayerIframe({ url, ...rest }) {
  const getEmbedUrl = () => {
    if (url.includes("shorts")) {
      return url.replace("shorts", "embed");
    } else {
      return `https://www.youtube.com/embed/${getYoutubeId(url)}`;
    }
  };
  return (
    <Box w="full" h="full" rounded="lg" overflow="hidden" {...rest}>
      <iframe
        style={{ width: "100%", height: "100%" }}
        title="Youtube player"
        sandbox="allow-same-origin allow-forms allow-popups allow-scripts allow-presentation"
        src={getEmbedUrl()}
        type="video/mp4"
        controls
      ></iframe>
    </Box>
  );
}
